import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 60px; 
      height: 45px;
    }`
  }
`

const ChartLineIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="83.265" height="57.402" isFromWidgetChoice={isFromWidgetChoice} viewBox="0 0 83.265 57.402">
      <path className="fillHoverSVG" id="chart_line" d="M82,138.252a7.578,7.578,0,0,0,6.3-11.819l13.07-23.174a.738.738,0,0,0,.209.07,8.082,8.082,0,0,0,1.321.463l.209.07a7.832,7.832,0,0,0,1.669.185,7.723,7.723,0,0,0,1.808-.232,2.937,2.937,0,0,0,.417-.139,6.534,6.534,0,0,0,1.112-.44c.093-.046.209-.07.3-.116l8.621,11.7a9.3,9.3,0,0,0-.556,1.066c-.023.046-.046.116-.07.162a10.235,10.235,0,0,0-.348,1.112c-.023.116-.046.209-.07.324a6.673,6.673,0,0,0-.139,1.367,7.6,7.6,0,1,0,15.2,0,6.4,6.4,0,0,0-.139-1.321c-.023-.116-.046-.255-.07-.371a8.109,8.109,0,0,0-.324-1.066,4.381,4.381,0,0,0-.255-.579c-.023-.07-.07-.139-.093-.209L146.8,95.287a7.369,7.369,0,0,0,3.268.765,7.6,7.6,0,0,0,0-15.2,7.705,7.705,0,0,0-7.624,7.694,7.612,7.612,0,0,0,1.414,4.4l-16.291,19.628a7.411,7.411,0,0,0-7.717-.278L111.2,100.548a7.583,7.583,0,1,0-12.723.162l-13.093,23.2A7.528,7.528,0,0,0,82,123.073a7.59,7.59,0,1,0,0,15.179ZM150.04,84.743a3.8,3.8,0,1,1-3.8,3.8A3.8,3.8,0,0,1,150.04,84.743ZM119.705,118.16a.177.177,0,0,1,.046-.116,2.415,2.415,0,0,1,.185-.579c0-.023.023-.023.023-.046a3.777,3.777,0,0,1,3.476-2.271,3.673,3.673,0,0,1,2.642,1.043l.255.3a3.746,3.746,0,0,1,.9,2.433,3.8,3.8,0,1,1-7.6,0A4.267,4.267,0,0,1,119.705,118.16ZM104.8,92.669a3.789,3.789,0,0,1,2.572,6.581,3.873,3.873,0,0,1-5.075.023,3.776,3.776,0,0,1,2.5-6.6ZM82,126.851a3.8,3.8,0,1,1-3.8,3.8A3.8,3.8,0,0,1,82,126.851Z" transform="translate(-74.4 -80.85)" fill="#707070"/>
    </SVG>
  </IconContainer>
)

export default ChartLineIcon